"use client"

import { CloudFog } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CloudFogIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CloudFogIcon = component(Icon)({ as: CloudFog })
